<template>
    <div>
        <template v-if="isPageNotFound">
            <b-alert
                show
                variant="danger"
            >
                <h1 class="col-12 text-center">
                    404
                </h1>
                <h2 class="col-12 text-center">
                    {{ $t("main.error") }}
                </h2>
            </b-alert>
        </template>

        <template v-if="isNotAvailableOnMobile">
            <b-alert
                show
                variant="danger"
                class="mb-4"
            >
                <div class="col-12 text-center mb-3">
                    <img
                        src="/img/pc-phone-transfer.svg"
                        width="40"
                        height="40"
                        loading="lazy"
                        :alt="$t('main.errorIsNotAvailableOnMobile')"
                    >
                </div>
                <h2 class="col-12 text-center mobile-error-message">
                    {{ $t("main.errorIsNotAvailableOnMobile") }}
                </h2>
            </b-alert>
            <return />
        </template>
    </div>
</template>

<script>
import Return from '@/components/Return';
import { ERROR_CODES } from '@/helpers/constants';

export default {
    name: 'ErrorComponent',
    components: {
        Return,
    },

    props: {
        errorCode: {
            type: Number,
            'default': null,
        },
    },

    computed: {
        isPageNotFound() {
            return this.errorCode === ERROR_CODES.pageNotFound;
        },

        isNotAvailableOnMobile() {
            return this.errorCode === ERROR_CODES.isNotAvailableOnMobile;
        },
    },
};
</script>

<style lang="scss" scoped>
.mobile-error-message {
    font-size: 18px;
    color: #2F2F2F;
    font-weight: 600;
}
</style>